import { assertIsNotNullish } from "@jaybeeuu/is";
export function multiPartition(array, ...predicates) {
    return array.reduce((acc, value) => {
        const index = predicates.findIndex((predicate) => predicate(value));
        if (index >= 0) {
            const partition = acc[index];
            assertIsNotNullish(partition);
            partition.push(value);
        }
        return acc;
    }, Array.from({ length: predicates.length }, () => []));
}
//# sourceMappingURL=multi-partition.js.map